/*
 * @Author: zerui.yao
 * @Date: 2022-12-08 15:23:52
 * @LastEditors: zerui.yao
 * @LastEditTime: 2024-02-01 17:53:57
 * @FilePath: /fed-authority/src/router/log.js
 * @Description:
 */
import loaded from '@/utils/util.import';

export default [
  // 权限日志-角色/权限
  {
    path: '/log/rolePoint',
    name: 'LogRolePoint',
    meta: {
      title: 'common.pageTitle.logRolePoint',
      keepAlive: false,
      perms: ['log:rolePoint:view'],
    },
    component: loaded('Log/rolePoint'),
  },
  {
    path: '/log/person',
    name: 'LogPerson',
    meta: {
      title: 'common.pageTitle.logPerson',
      keepAlive: false,
      perms: ['log:person:view'],
    },
    component: loaded('Log/person'),
  },
];
